import styled from 'styled-components'
import { WhiteBlock } from 'components/Layout'
import theme from 'theme_'
import { Font14 } from 'components/Typography'
import CommonLinkButton from 'components/Button/CommonLinkButton'
import Icon from '@mdi/react'
import { Form } from 'formik'
import CommonButton from 'components/Button/CommonButton'

export const JobDetailsLocationContainer = styled(WhiteBlock)`
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`
export const JobDetailsGoogleMapContainer = styled.div`
  margin-bottom: 16px;
  border-radius: 8px;
  overflow: hidden;
`

export const JobDetailsLocationHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 26px;
  margin-bottom: 24px;
  width: 100%;
`

export const JobDetailsLocationTitle = styled.div`
  color: ${theme.colors.moreGrey};
  ${Font14};
`

export const JobDetailsLocationEditButton = styled(CommonLinkButton)``

export const JobDetailsLocationStyledIcon = styled(Icon)`
  height: 20px;
  width: 20px;
  color: ${theme.colors.horizonOrange};

  :hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const JobDetailsLocationForm = styled(Form)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const JobDetailsLocationFormContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  input {
    margin-bottom: 24px;
  }
`

export const JobDetailsLocationFormControl = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: 10px;
  animation: ${theme.animations.fadeIn} 0.2s ease-out;
`

export const JobDetailsLocationCancelButton = styled(CommonButton)`
  background: transparent;
`

export const JobDetailsLocationSubmitButton = styled(CommonButton)``

export const JobDetailsLocationButtonsWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  min-width: 240px;
  min-height: 42px;
`
